(function (ng, app) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTrackerNew.Contacts.ContactList",
                    {
                        url: "",
                        component: "contactList",
                        PageTitle: "Contact List | Marketing Tracker"
                    });
        }
    ]);

    app.component("contactList",
        {
            templateUrl: "App/Tools/MarketingTrackerNew/Contacts/ContactList/contact-list-template.html",
            controller: contactListController
        });

    contactListController.$inject = ['marketingTrackerContactApi', 'figToaster', 'amplitudeService', '_', '$mdDialog', '$timeout', 'marketingTrackerConstantContactApi'];
    function contactListController(marketingTrackerContactApi, figToaster, amplitudeService, _, $mdDialog, $timeout, marketingTrackerConstantContactApi) {
        const $ctrl = this;

        ng.extend($ctrl,
            {
                //We can programmatically assign an origin when we can add a contact from multiple sources on this page
                loadingData: false,
                toggleSort: toggleSort,
                addContactModal: addContactModal,
                undoDeleteContact: undoDeleteContact,
                deleteContactWithUndo: deleteContactWithUndo,
                refreshData: refreshData,
                syncConstantContactContacts: syncConstantContactContacts,
                pageSizes: [25, 50, 100],
                ui: {
                    hasCCToken: false
                }
            }
        );


        var toastMessage, toastClass;

        function _getContactList() {
            $ctrl.loadingData = true;
            marketingTrackerContactApi.getContactList()
                .then(function (response) {
                    _.forEach(response, function (contact) {
                        if (contact.ActOnLeadScore === null) {
                            contact.ActOnLeadScore = 0;
                        }
                        if (contact.Email === null) { 
                            contact.Email = '';
                        }
                    });
                    $ctrl.contactList = response;
                })
                .catch(function () {
                    console.log('Error getting contact list');
                    toastMessage = "There was a problem loading your contact. Please try again shortly.";
                    toastClass = "is-error";
                    figToaster.showSimple(toastMessage, "top", toastClass);
                })
                .finally(function () {
                    $ctrl.loadingData = false;
                });
        }

        function _resetFilters(propertyName, pageSize, reverseOrder, currentPage, contactSearch) {
            $ctrl.propertyName = propertyName || 'FirstName';
            $ctrl.pageSize = pageSize || $ctrl.pageSizes[0];
            $ctrl.reverseOrder = reverseOrder || false;
            $ctrl.currentPage = currentPage || 1;
            $ctrl.contactSearch = contactSearch || '';
        }

        function toggleSort(propertyName) {
            $ctrl.reverseOrder = $ctrl.propertyName === propertyName ? !$ctrl.reverseOrder : false;
            $ctrl.propertyName = propertyName;
        }

        function _deleteContact(contact) {
            marketingTrackerContactApi.deleteContact(contact.Id)
                .then(function () {
                    $ctrl.contactList = _.without($ctrl.contactList, contact);
                    toastMessage = "Contact deleted.";
                    toastClass = "is-success";
                })
                .catch(function () {
                    console.log('Could not delete contact');
                    toastMessage = "There was a problem deleting your contact. Please try again shortly.";
                    toastClass = "is-error";
                })
                .finally(function () {
                    figToaster.showSimple(toastMessage, "top", toastClass);
                    contact.showUndo = false;
                });
        }

        function deleteContactWithUndo(contact) {
            contact.showUndo = true;
            contact.deferDelete = $timeout(function () {
                _deleteContact(contact);
            }, 1800);

        }

        function undoDeleteContact(contact) {
            $timeout.cancel(contact.deferDelete);
            contact.showUndo = false;
        }

        function addContactModal($event) {
            return $mdDialog.show({
                templateUrl: "App/Tools/MarketingTrackerNew/Components/AddContact/add-contact.component.html",
                controller: "addContactController",
                controllerAs: "$ctrl",
                targetEvent: $event,
                bindToController: true
            })
                .then(function (response) {
                    amplitudeService.logClickEvent('Added Contact Manually');
                    $ctrl.contactList.push(response);
                    _resetFilters($ctrl.propertyName, $ctrl.pageSize);
                    $ctrl.contact = {};
                    toastMessage = "Contact added.";
                    toastClass = "is-success";
                    figToaster.showSimple(toastMessage, "top", toastClass);
                });
        }

        function refreshData() {
            _getContactList();
            _resetFilters();
        }

        function syncConstantContactContacts() {
            $ctrl.loadingData = true;
            amplitudeService.logClickEvent('Sync CC Button');
            marketingTrackerConstantContactApi.syncContacts()
                .then(function (response) {
                    $ctrl.loadingData = false;
                    toastClass = "is-success";
                    figToaster.showSimple(response, "top", toastClass);
                    refreshData();
                })
                .catch(function (error) {
                    $ctrl.loadingData = false;
                    console.log("Error: " + error.data);
                    var message = "There was a problem retrieving your data. Please try again shortly.";
                    toastClass = "is-error";
                    figToaster.showSimple(message, "top", toastClass);
                });
        }

        $ctrl.$onInit = function () {
            refreshData();
            marketingTrackerConstantContactApi.getHasToken()
                .then(function (hasToken) {
                    if (hasToken) {
                        $ctrl.ui.hasCCToken = true;
                    }
                });
        };
    }

})(window.angular, window.app); //jshint ignore:line